let itm = {
  bcg: require('./bcg_plakaty.png'),
  animals: require('./pla/bcg_anim_t.png'),
  items: [
    {
      // disable: true,
      bcg: require('./pla/bcg_v.png'),
      cssStyle: {
        position: 'absolute',
        top: '33%',
        left: '5%',
        height: '61.5%',
        width: '21%',
      },
      elem: [
        {
          bcg: require('./pla/v_1.png'),
          cssStyle: {
            position: 'absolute',
            left: '11%',
            top: '10%',
            height: '13.7%',
            width: '33%',
          },
          redirect: 'page000_game0',
          type: 'game',
        },
        {
          bcg: require('./pla/v_2.png'),
          cssStyle: {
            position: 'absolute',
            left: '55.5%',
            top: '10%',
            height: '13.7%',
            width: '33%',
          },
          redirect: 'page000_game1',
          type: 'game',
        },
        //
        {
          disable: true,
          bcg: require('./pla/v_3.png'),
          cssStyle: {
            position: 'absolute',
            left: '11%',
            top: '27.5%',
            height: '14%',
            width: '33%',
          },
        },
        {
          disable: true,
          bcg: require('./pla/v_4.png'),
          cssStyle: {
            position: 'absolute',
            left: '55.5%',
            top: '27.5%',
            height: '14%',
            width: '33%',
          },
        },
        //
        {
          disable: true,
          bcg: require('./pla/v_5.png'),
          cssStyle: {
            position: 'absolute',
            left: '11%',
            top: '45.3%',
            height: '14%',
            width: '33%',
          },
        },
        {
          disable: true,
          bcg: require('./pla/v_6.png'),
          cssStyle: {
            position: 'absolute',
            left: '55.5%',
            top: '45.3%',
            height: '14%',
            width: '33%',
          },
        },
        //
        {
          disable: true,
          bcg: require('./pla/v_7.png'),
          cssStyle: {
            position: 'absolute',
            left: '11%',
            top: '62.7%',
            height: '14%',
            width: '33%',
          },
        },
        {
          disable: true,
          bcg: require('./pla/v_8.png'),
          cssStyle: {
            position: 'absolute',
            left: '55.5%',
            top: '62.7%',
            height: '14%',
            width: '33%',
          },
        },
        //
        {
          disable: true,
          bcg: require('./pla/v_9.png'),
          cssStyle: {
            position: 'absolute',
            left: '11%',
            top: '80.7%',
            height: '14%',
            width: '33%',
          },
        },
        {
          disable: true,
          bcg: require('./pla/v_10.png'),
          cssStyle: {
            position: 'absolute',
            left: '55.5%',
            top: '80.7%',
            height: '14%',
            width: '33%',
          },
        },
      ],
    },
    {
      // disable: true,
      bcg: require('./pla/bcg_s.png'),
      cssStyle: {
        position: 'absolute',
        top: '33%',
        left: '28%',
        height: '61.5%',
        width: '21%',
      },
      elem: [
        {
          bcg: require('./pla/s_1.png'),
          cssStyle: {
            position: 'absolute',
            left: '11%',
            top: '10%',
            height: '13.7%',
            width: '33%',
          },
          redirect: 'page001_game0',
          type: 'game',
        },
        {
          bcg: require('./pla/s_2.png'),
          cssStyle: {
            position: 'absolute',
            left: '56%',
            top: '10%',
            height: '13.7%',
            width: '33%',
          },
          redirect: 'page001_game1',
          type: 'game',
        },
        //
        {
          disable: true,
          bcg: require('./pla/s_3.png'),
          cssStyle: {
            position: 'absolute',
            left: '11%',
            top: '27.7%',
            height: '13.7%',
            width: '33%',
          },
        },
        {
          disable: true,
          bcg: require('./pla/s_4.png'),
          cssStyle: {
            position: 'absolute',
            left: '56%',
            top: '27.7%',
            height: '13.7%',
            width: '33%',
          },
        },
        //
        {
          disable: true,
          bcg: require('./pla/s_5.png'),
          cssStyle: {
            position: 'absolute',
            left: '11%',
            top: '45.5%',
            height: '13.7%',
            width: '33%',
          },
        },
        {
          disable: true,
          bcg: require('./pla/s_6.png'),
          cssStyle: {
            position: 'absolute',
            left: '56%',
            top: '45.5%',
            height: '13.7%',
            width: '33%',
          },
        },
        //
        {
          disable: true,
          bcg: require('./pla/s_7.png'),
          cssStyle: {
            position: 'absolute',
            left: '11%',
            top: '63%',
            height: '13.7%',
            width: '33%',
          },
        },
        {
          disable: true,
          bcg: require('./pla/s_8.png'),
          cssStyle: {
            position: 'absolute',
            left: '56%',
            top: '63%',
            height: '13.7%',
            width: '33%',
          },
        },
        //
        {
          disable: true,
          bcg: require('./pla/s_9.png'),
          cssStyle: {
            position: 'absolute',
            left: '11%',
            top: '80.5%',
            height: '13.7%',
            width: '33%',
          },
        },
        {
          disable: true,
          bcg: require('./pla/s_10.png'),
          cssStyle: {
            position: 'absolute',
            left: '56%',
            top: '80.5%',
            height: '13.7%',
            width: '33%',
          },
        },
      ],
    },
    {
      // disable: true,
      bcg: require('./pla/bcg_r.png'),
      cssStyle: {
        position: 'absolute',
        top: '33%',
        left: '51%',
        height: '40%',
        width: '21%',
      },
      elem: [
        {
          bcg: require('./pla/r_1.png'),
          cssStyle: {
            position: 'absolute',
            left: '11%',
            top: '15%',
            height: '21%',
            width: '33%',
          },
          redirect: 'page000_game2',
          type: 'game',
        },
        {
          disable: true,
          bcg: require('./pla/r_2.png'),
          cssStyle: {
            position: 'absolute',
            left: '55%',
            top: '15%',
            height: '21%',
            width: '33%',
          },
        },
        //
        {
          disable: true,
          bcg: require('./pla/r_3.png'),
          cssStyle: {
            position: 'absolute',
            left: '11%',
            top: '42.7%',
            height: '21%',
            width: '33%',
          },
        },
        {
          disable: true,
          bcg: require('./pla/r_4.png'),
          cssStyle: {
            position: 'absolute',
            left: '55%',
            top: '42.7%',
            height: '21%',
            width: '33%',
          },
        },
        //
        {
          disable: true,
          bcg: require('./pla/r_5.png'),
          cssStyle: {
            position: 'absolute',
            left: '11%',
            top: '70%',
            height: '21%',
            width: '33%',
          },
        },
      ],
    },
    {
      disable: true,
      bcg: require('./pla/bcg_f.png'),
      cssStyle: {
        position: 'absolute',
        top: '33%',
        left: '74%',
        height: '29%',
        width: '21%',
      },
      elem: [
        {
          bcg: require('./pla/f_1.png'),
          cssStyle: {
            position: 'absolute',
            left: '11%',
            top: '21%',
            height: '29%',
            width: '33%',
          },
        },
        {
          bcg: require('./pla/f_2.png'),
          cssStyle: {
            position: 'absolute',
            left: '55.5%',
            top: '21%',
            height: '29%',
            width: '33%',
          },
        },
        //
        {
          bcg: require('./pla/f_3.png'),
          cssStyle: {
            position: 'absolute',
            left: '11%',
            top: '59%',
            height: '29%',
            width: '33%',
          },
        },
        {
          bcg: require('./pla/f_4.png'),
          cssStyle: {
            position: 'absolute',
            left: '55.5%',
            top: '59%',
            height: '29%',
            width: '33%',
          },
        },
      ],
    },
    {
      disable: true,
      bcg: require('./pla/bcg_e.png'),
      cssStyle: {
        position: 'absolute',
        top: '63.7%',
        left: '74%',
        height: '18%',
        width: '21%',
      },
      elem: [
        {
          bcg: require('./pla/ex.png'),
          cssStyle: {
            position: 'absolute',
            top: '34%',
            left: '11%',
            height: '47%',
            width: '33%',
          },
        },
      ],
    },
  ],
};

export default itm;
